module.exports = __webpack_public_path__ + "static/media/valor1.fc7cccef.png";